/**
 * Busca em todos os manuais (e nos motivos de pausa já usados), ignorando
 * acentos. Cada resultado leva direto ao passo no manual.
 */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { EmptyState } from "../../components/EmptyState";
import { useAuth } from "../../context/AuthContext";
import { buscarNosManuais, ehFalhaDeRede } from "../../services/areaPcp";
import Casca, { BASE } from "./Casca";
import { ROTA_EXECUCAO } from "./componentes/IniciarExecucao";
import { useAreaPcp } from "./offline/AreaPcpContext";
import { Aviso, BotaoTexto, Campo, Corpo, Linha, Lista, Meta, Selo, Sub } from "./styles";

const MINIMO = 2;

function Trecho({ trecho }) {
  return (
    <Sub style={{ whiteSpace: "normal" }}>
      {trecho.antes}
      <mark style={{ background: "var(--accent-soft)", color: "var(--ink)", borderRadius: 3, padding: "0 2px" }}>{trecho.achado}</mark>
      {trecho.depois}
    </Sub>
  );
}

export default function Busca() {
  const { request } = useAuth();
  const { pacote } = useAreaPcp();
  const navigate = useNavigate();
  const [termo, setTermo] = useState("");
  const [estado, setEstado] = useState({ resultado: null, erro: "" });

  useEffect(() => {
    if (termo.trim().length < MINIMO) {
      setEstado({ resultado: null, erro: "" });
      return undefined;
    }
    let ativo = true;
    const timer = setTimeout(() => {
      buscarNosManuais(request, termo.trim())
        .then((resultado) => ativo && setEstado({ resultado, erro: "" }))
        .catch((falha) => ativo && setEstado({
          resultado: null,
          erro: ehFalhaDeRede(falha) ? "Sem conexão: a busca precisa de internet. Os manuais continuam abertos em Tarefas." : falha.message,
        }));
    }, 300);
    return () => {
      ativo = false;
      clearTimeout(timer);
    };
  }, [request, termo]);

  const abrir = (r) => {
    if (r.tipo === "pausa") navigate(ROTA_EXECUCAO(r.execucao_id));
    else if (r.passo_chave) navigate(`${BASE}/tarefas/${r.tarefa_id}#passo-${r.passo_chave}`);
    else navigate(`${BASE}/tarefas/${r.tarefa_id}`);
  };

  const { resultado, erro } = estado;
  return (
    <Casca contagemAbertas={(pacote?.execucoes || []).length}>
      <Campo>
        <span>Buscar nos manuais</span>
        <input
          type="search"
          value={termo}
          onChange={(e) => setTermo(e.target.value)}
          placeholder="Ex.: qr code, seccionadora, EXPORT CVL"
          autoFocus
        />
        <span className="dica">A busca ignora acentos e maiúsculas.</span>
      </Campo>
      {erro ? <Aviso $tom="warning">{erro}</Aviso> : null}
      {resultado && !resultado.total ? (
        <EmptyState tone="search" titulo="Nada encontrado" descricao="Tente uma palavra só, como “desligada” ou “máquina”." />
      ) : null}
      {resultado?.total ? (
        <>
          <Meta>
            {resultado.total} {resultado.total === 1 ? "resultado" : "resultados"} em {resultado.tarefas}{" "}
            {resultado.tarefas === 1 ? "tarefa" : "tarefas"}
          </Meta>
          <Lista aria-label="Resultados">
            {resultado.resultados.map((r, i) => (
              <Linha key={`${r.tarefa_id}-${r.passo_chave || r.campo || r.execucao_id}-${i}`}>
                <Corpo>
                  <Meta>
                    <strong>{r.onde}</strong> · {r.tarefa_titulo}
                    {r.tipo === "pausa" ? " · motivo de pausa salvo" : ""}
                    {r.tem_aviso ? <Selo $tom="warning">passo com aviso</Selo> : null}
                  </Meta>
                  <Trecho trecho={r.trecho} />
                </Corpo>
                <BotaoTexto type="button" onClick={() => abrir(r)}>
                  {r.tipo === "pausa" ? "Abrir execução" : r.passo_chave ? "Abrir no passo" : "Abrir no manual"}
                </BotaoTexto>
              </Linha>
            ))}
          </Lista>
        </>
      ) : null}
    </Casca>
  );
}
